import { render, staticRenderFns } from "./addDataPrivilegeStaff.vue?vue&type=template&id=6fc6ba9d&scoped=true"
import script from "./addDataPrivilegeStaff.vue?vue&type=script&lang=js"
export * from "./addDataPrivilegeStaff.vue?vue&type=script&lang=js"
import style0 from "./addDataPrivilegeStaff.vue?vue&type=style&index=0&id=6fc6ba9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6ba9d",
  null
  
)

export default component.exports